import { useEffect } from 'react';

import HeaderExtra from '../components/HeaderExtra'
import Footer from '../components/Footer.jsx';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

import '../Assets/css/hoteldetails.css'
import '../Assets/css/myprofile.css'
import '../Assets/css/photocropper.css'

// import Cropper from '../Assets/js/fixed-cropper.js';

import  '../Assets/js/photocropper.js'
import  '../Assets/js/myprofile.js'

function MyProfile()
{
  useEffect(() =>
  {
    window.CallDefaultFunction("MyProfile");
  }, []);

  return (
    <>
      <div className="basic">

        <HeaderExtra page="My Profile"/>

        <div className="MainContentSection" id="AllMainContentSection">
          <div className="MainSectionBasicWithBlue ImageBackgroundTopMyProfile">
            <div className="SectionWrapperMyProfile">
              <div className="LeftSectionMyProfile" id="LeftSectionMyProfile">
                <img src="/Assets/images/ProfilePicture.jpg" className="ImageFullCover ImageBackgroundMyProfile" id="ProfilePictureBackgroundMyProfile" />
                <div className="loading_grey ImageFullCover ImageBackgroundMyProfile" id="LoadingBackgroundMyProfile" style={{opacity:0}}></div>
                <div className="ProfileImageContainer" id="ProfileImageContainer">
                  <img src="/Assets/images/ProfilePicture.jpg" className="ImageFullCover" id="ProfilePictureMyProfile" />
                </div>
                <button className="BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ButtonUnselectable" id="EditPhotoMyProfileButton" style={{margin:"0 auto"}}>
                  <div style={{width:"fit-content",height:"fit-content",display:"flex",margin:"auto 0"}}>
                    <img className="BasicIconInsideButton2 PencilEditIcon" style={{marginLeft:"0"}} />
                    <p id="EditPhotoButtonText">Edit Photo</p>
                  </div>
                </button>
              </div>
              <div className="RightSectionMyProfile">
                <div className="BasicRadius MarginTextUpDown RedWarningContainer WarningTextMarginTop WarningTopMyProfileHide" id="RedWarningReferralContainer">
                  <p className="InterMediumTextFont" id="RedWarningReferralText">Invalid Email Format!</p>
                </div>
                <div className="TwoSeparatorWrapper InputFieldMargin">
                  <div className="TwoSeparatorContent">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="FirstNameHeaderTextMyProfile">First Name</p>
                    <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width:"100%",minWidth:"100%"}} id="FirstNameMyProfileInputContainer">
                      <input type="text" name="FirstName" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="Input first name" id="FirstNameMyProfileInput" />
                    </div>
                    <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="FirstNameMyProfileWarning">Sample Warning</p>
                  </div>
                  <div className="TwoSeparatorContent">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="LastNameHeaderTextMyProfile">Last Name</p>
                    <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width:"100%",minWidth:"100%"}} id="LastNameMyProfileInputContainer">
                      <input type="text" name="LastName" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="Input last name" id="LastNameMyProfileInput" />
                    </div>
                    <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="LastNameMyProfileWarning">Sample Warning</p>
                  </div>
                </div>
                <div className="InputFieldMargin">
                  <p className="InputFieldHeaderText InterMediumTextFont" id="EmailHeaderTextMyProfile">Email</p>
                  <div className="SmallPanelDropDownContainer BasicInputFieldContainer InputFieldContainerInvalid" style={{width:"100%",minWidth:"100%",pointerEvents:"none"}} id="EmailMyProfileInputContainer">
                    <input type="email" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="e.g.: sample@gmail.com" id="EmailMyProfileInput" readOnly />
                  </div>
                  <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="EmailMyProfileWarning">Sample Warning</p>
                </div>
                <div className="InputFieldMargin BasicHeaderAndInputWrapper" style={{marginTop:"0"}}>
                  <p className="InputFieldHeaderText InterMediumTextFont" id="GenderHeaderMyProfile">Gender</p>
                  <div style={{display:"flex", WebkitFlexDirection:"row", msFlexDirection:"row",flexDirection:"row"}}>
                    <div className="CheckBoxMarginBasic">
                      <label className="FilterCheckBoxContainer">
                        <input type="radio" className="FilterCheckBox Selectable" defaultValue="Male" name="GenderMyProfileCheckBox" />
                        <span className="CheckBoxSpan" />
                      </label>
                      <p className="CheckBoxText InterMediumTextFont" id="MaleCheckBoxTextMyProfile">Male</p>
                    </div>
                    <div className="CheckBoxMarginBasic">
                      <label className="FilterCheckBoxContainer">
                        <input type="radio" className="FilterCheckBox Selectable" defaultValue="Female" name="GenderMyProfileCheckBox" />
                        <span className="CheckBoxSpan" />
                      </label>
                      <p className="CheckBoxText InterMediumTextFont" id="FemaleCheckBoxTextMyProfile">Female</p>
                    </div>
                  </div>
                </div>
                <div className="InputFieldMargin">
                  <p className="InputFieldHeaderText InterMediumTextFont" id="PhoneNumberHeaderTextMyProfile">Phone Number</p>
                  <div className="SmallPanelDropDownContainer" id="PhoneNumberMyProfileInputContainer">
                    <div className="FirstNumberPhoneNumberWrapper" id="MyProfileCountryCode" country-code="62" is-change="false">
                      <div className="PhoneCodeNumberTextWrapper Selectable3">
                        <p className="InterMediumTextFont" id="MyProfileCountryCodeText">+62</p>
                      </div>
                    </div>
                    <input type="number" className="InputFieldInsideSmallPanel InputFieldWithButton Selectable3 InterMediumTextFont" placeholder={81000000} previous-input="" id="PhoneNumberMyProfileInput" />
                  </div>
                  <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="PhoneNumberMyProfileWarning">Sample Warning</p>
                </div>
                <div className="InputFieldMargin">
                  <p className="InputFieldHeaderText InterMediumTextFont" id="CountryHeaderTextMyProfile">Country</p>
                  <div className="SmallPanelDropDownContainer" id="CountryPaymentFormDropDownContainer" country-selected="Indonesia" original-country="">
                    <div className="SmallPanelDropDownInputWrapper Selectable3 InterMediumTextFont">
                      <img src="/Assets/images/CountryCode/Indonesia.svg" className="CircleInsideInputField" id="CountryFlagPaymentFormIcon" />
                      <p id="CountryPaymentFormText">Indonesia</p>
                      <img className="ChevronInsideInput ToggleArrow" id="CountryPaymentFormToggleArrow" src="/Assets/images/ButtonIcon/chevron.svg" style={{"rotate":"0deg"}} />
                    </div>
                  </div>
                  <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="CountryPaymentFormWarning">Sample Warning</p>
                </div>
                <div className="InputFieldMargin">
                  <p className="InputFieldHeaderText InterMediumTextFont" id="IDCardHeaderTextMyProfile">ID Card</p>
                  <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width:"100%",minWidth:"100%"}} id="IDCardMyProfileContainer">
                    <input type="text" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="Input your ID Card" previous-input="" is-change="false" id="IDCardMyProfileInput" />
                  </div>
                  <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="IDCardMyProfileWarning">Sample Warning</p>
                </div>
                <div className="InputFieldMargin2" id="MyReferralCodeMyProfileContainer" style={{display:"none", flexDirection:"column"}}>
                  <p className="InputFieldHeaderText InterMediumTextFont" id="MyReferralCodeHeaderText">My Referral Code</p>
                  <div className="ReferralInputAndButtonWrapper">
                    <div className="SmallPanelDropDownContainer BasicMarginLR" style={{WebkitFlex:"1",msFlex:"1",flex:"1",marginLeft:"0",WebkitFilter:"brightness(90%)"}}>
                      <div className="SmallPanelDropDownInputWrapper InterMediumTextFont">
                        <p id="MyReferralCodeText">REF1234</p>
                        <img className="BasicIconInsideButton Selectable2" src="/Assets/images/ButtonIcon/copy-orange.svg" style={{marginRight:"0"}} id="CopyReferralButton" />
                      </div>
                    </div>
                    <button className="BasicTextButton BasicBoxShadow OrangeButton ButtonResizeFollowInput SignInButtonTop Selectable" style={{marginTop:"0",width:"fit-content !important"}} id="ShareReferralButtonMyPage">
                      <div style={{width:"auto !important",height:"fit-content",display:"inline-flex",margin:"auto 0",padding:"0"}}>
                        <img className="BasicIconInsideButton2" src="/Assets/images/ButtonIcon/share-white-icon.svg" style={{marginLeft:"0"}} />
                        <p id="ShareReferralBtnText" style={{width:"fit-content",whiteSpace:"nowrap"}}>Bagikan Kode Referral</p>
                      </div>
                    </button>
                  </div>
                  <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="IDCardMyProfileWarning">Sample Warning</p>
                </div>
                <div className="ReferralInputAndButtonContainer">
                  <div className="ReferralWrapperTopSection BasicRadius">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="ReferralHeaderText" style={{"color":"#FFFFFF"}}>Do you have Referral Code?</p>
                    <div style={{width:"auto",display:"flex"}}>
                      <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" id="ReferralMyProfileContainer">
                        <input type="text" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="Input yout friends Referral Code" id="ReferralMyProfileInput" />
                      </div>
                      <button className="BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop ButtonUnselectable" id="CheckReferralButton">
                        <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto 0"}}>
                          <img className="BasicIconInsideButton2 AddReferralIcon" style={{marginLeft:"0"}} />
                          <p id="CheckReferralButtonText">Add Referral</p>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className="ReferralWrapperBottomSection BasicRadius">
                    <img src="/Assets/images/Icon/gift-box-login-sekarang.svg" className="RefPrizeIconMyProfile" style={{marginLeft:"0",marginTop:"auto",marginBottom:"auto"}} />
                    <p className="InputFieldHeaderText InterMediumTextFont" id="RefBottomMessage" style={{"color":"#FFFFFF","margin":"auto 0"}}>Dapatkan voucher diskon + referral poin setelah referral ter-verifikasi</p>
                  </div>
                </div>
                <div className="InputFieldMargin">
                  <button className="BasicTextButton BasicBoxShadow OrangeButton SaveButtonMyProfile PaddingExtendedButton ButtonUnselectable" style={{marginLeft:"auto"}} id="SaveChangesButton">
                    <div style={{width:"fit-content",height:"fit-content",display:"flex","margin":"auto 0"}}>
                      <p id="SaveButtonText">Save</p>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <RightPanelMobile/>
      <Footer/>
    </>
  )
}

export default MyProfile